const Pallete = {
    'Charlotte-Green': '#005035',
    'Niner-Gold': '#A49665',
    'Quartz-White':'#FFFFFF',
    'Darker-Green': '#003B27',
    'Black':'#000000',
    'Purple':'#080835'

}
export default Pallete 